import { useEffect, useRef, useState } from 'react';
import { getBlueprint } from '@/lib/api';

const POLL_MS = 3000;

/**
 * Load a Creative Blueprint and keep polling while LXRA Intelligence is still
 * composing it (or regenerating a section). Stops automatically on completion.
 */
export const useBlueprintPoll = (id) => {
  const [bp, setBp] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setBp(null);
    setNotFound(false);
    const load = async () => {
      try {
        const data = await getBlueprint(id);
        if (cancelled) return;
        setBp(data);
        if (data.status === 'generating' || data.section_generating) {
          timer.current = setTimeout(load, POLL_MS);
        }
      } catch (err) {
        if (!cancelled) setNotFound(true);
      }
    };
    load();
    return () => {
      cancelled = true;
      if (timer.current) clearTimeout(timer.current);
    };
  }, [id]);

  return { bp, notFound };
};
